const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Validate environment variables are loaded
if (!SUPABASE_URL) {
  throw new Error('VITE_SUPABASE_URL environment variable is not set');
}

if (!SUPABASE_ANON_KEY) {
  throw new Error('VITE_SUPABASE_ANON_KEY environment variable is not set');
}

export interface AppliedPromocode {
  id: string;
  code: string;
  type: 'percentage' | 'fixed_amount';
  value: number;
  discountAmount: number;
}

export async function applyPromocodeToCart(code: string, cartTotal: number): Promise<AppliedPromocode> {
  try {
    // Double-check environment variables before making the request
    if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
      throw new Error('Supabase configuration is missing. Please check environment variables.');
    }

    const functionUrl = `${SUPABASE_URL}/functions/v1/apply-promocode`;
    console.log('Calling promocode function at:', functionUrl);

    const response = await fetch(functionUrl, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${SUPABASE_ANON_KEY}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        code: code.trim(),
        cartTotal: cartTotal
      })
    });

    const data = await response.json();

    if (!response.ok || !data.success) {
      throw new Error(data.error || 'Sooduskoodi rakendamine ebaõnnestus');
    }

    return {
      id: data.promocode.id,
      code: data.promocode.code,
      type: data.promocode.type,
      value: data.promocode.value,
      discountAmount: data.promocode.discountAmount
    };
  } catch (error) {
    console.error('Error applying promocode:', error);
    
    // Provide more specific error messages
    if (error instanceof TypeError && error.message.includes('Failed to fetch')) {
      throw new Error('Ühenduse viga serveriga. Palun kontrolli internetiühendust.');
    }
    
    throw error;
  }
}